import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import config from '@/config'

// 路由
Vue.use(VueRouter)
const router = new VueRouter({
	mode: "history",
  routes
})

router.beforeEach((to, from, next) => {
  next()
})

router.afterEach(to => {
	document.title = config.systemName
  window.scrollTo(0, 0)
})

export default router
